import { serverTrackAndIdentify } from '../../../utils/segment';

export const trackDebtData = ({ eventData, userProperties }) => {
  return serverTrackAndIdentify({
    event: 'Calculator Interaction Occurred',
    eventProperties: {
      calculator_name: 'cost of debt',
      ...eventData,
    },

    userProperties,
  });
};

export const trackAddDebt = ({ typeOfDebt, balance, interestRate, monthlyPayment, debts }) => {
  return trackDebtData({
    eventData: {
      interaction_type: 'add debt',
      debt_type: typeOfDebt,
      debt_balance: balance,
      debt_rate: interestRate,
      debt_payment: monthlyPayment,
      number_of_debts: debts.length + 1,
    },
  });
};

export const trackRemoveDebt = ({ typeOfDebt, balance, interestRate, monthlyPayment, debts }) => {
  return trackDebtData({
    eventData: {
      interaction_type: 'remove debt',
      debt_type: typeOfDebt,
      debt_balance: balance,
      debt_rate: interestRate,
      debt_payment: monthlyPayment,
      number_of_debts: debts.length - 1,
    },
  });
};

export const trackFinishClick = ({
  debts,
  totalInterestPayments,
  totalMonthlyPayment,
  payOffDate,
  totalBalance,
  totalPrincipalBalance,
}) => {
  return trackDebtData({
    eventData: {
      interaction_type: 'complete',
      number_of_debts: debts.length,
      outcome_debt_types: debts.map((debt) => debt.label).join(','),
      outcome_debt_balance: parseInt(totalPrincipalBalance),
      outcome_debt_interest: parseInt(totalInterestPayments),
      outcome_debt_monthly_payments: totalMonthlyPayment,
      outcome_debt_free_by_date: payOffDate,
      outcome_debt_total: parseInt(totalBalance),
    },
    userProperties: {
      debt_calculator_total_debts: debts.length,
      debt_calculator_monthly_payments: totalMonthlyPayment,
      debt_calculator_balance: parseInt(totalPrincipalBalance),
      debt_calculator_total_interest: parseInt(totalInterestPayments),
      debt_calculator_total_balance: parseInt(totalBalance),
      debt_calculator_debt_free_date: payOffDate,
      debt_calculator_debt_types: debts.map((debt) => debt.typeOfDebt).join(','),
    },
  });
};

export const trackExportLink = ({
  debts,
  totalBalance,
  totalInterestPayments,
  totalMonthlyPayment,
  payOffDate,
  totalPrincipalBalance,
}) => {
  return trackDebtData({
    eventData: {
      interaction_type: 'export',
      outcome_debt_types: debts.map((debt) => debt.label).join(','),
      outcome_debt_balance: parseInt(totalPrincipalBalance),
      outcome_debt_total_balance: parseInt(totalBalance),
      outcome_debt_interest: totalInterestPayments,
      outcome_debt_monthly_payment: totalMonthlyPayment,
      outcome_debt_free_by_date: payOffDate,
    },
  });
};
